module.exports = __webpack_public_path__ + "images/moonshot/the-new-york-times.5eb5d2b8743497c877da.png";